export class ActiveFixedAssigmentEntity{
    
    id: number;
    identification: number;
    name: String;
    mail: String;
    costCenter: String;
    position: String;
    city: String;
    productEquip: String;
    serial: String;
    exitPermanent: boolean;
    statusEquipament: String;
    creationDate: Date;
    active: Boolean;
    product: string;
    personRes: string; 
    approvedRejected: string;
    nameRes: string;
    answer: string;
    person: string;
    exitEntry: Boolean;
    exitDate:Date;
    entryDate: Date;
    constructor (){}
}